/* 业务组件 */
export const components = {
  StaffSelect: () => import('../components/staffSelect/StaffSelect.vue'),
  ContactSelect: () => import('@/components/contactSelect/ContactSelect.vue')
}

export default {
  // 安装
  install(Vue, opts = {}) {
    Object.entries(components).forEach(([key, comp]) => {
      Vue.component(comp.name || key, comp)
    })
  },
  ...components
}
